import styled, { css } from "styled-components";
import { colors, screenSizes, typography } from "@streeteasy/design-system";
import ButtonAction, {
  buttonActionThemes
} from "@streeteasy/design-system/button-action";

import { calendarBrand } from "../../assets";

export const Title = styled(typography.PrimarySmall)`
  margin: 0 0 4px 0;

  ${({ isUpcoming }) =>
    !isUpcoming &&
    css`
      font-size: 22px;
      line-height: 32px;
    `}
`;

export const Wrapper = styled.div`
  max-width: 400px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    max-width: 100%;
  }

  &:not(:first-child) {
    border-top: 1px solid ${colors.GRAY_LIGHT};
    margin: 23px 0 0;
    padding: 24px 0 0;
  }

  &:first-child {
    ${Title} {
      font-size: 28px;
      line-height: 36px;
    }
  }
`;

export const CalendarCheckIcon = styled.img.attrs({
  alt: "open houses",
  "aria-hidden": true,
  src: calendarBrand
})``;

export const SubTitle = styled(typography.Caption)`
  color: ${colors.TEXT_SECONDARY};
  margin: 0 0 25px 0;
`;

export const ListWrapper = styled.div``;

export const ActionWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 25px 0 0;
`;

export const LoadMoreButton = styled(ButtonAction).attrs({
  type: "button",
  theme: buttonActionThemes.SECONDARY
})`
  height: 32px;
  min-width: 120px;
  padding: 0 12px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    height: 48px;
    width: 224px;
  }
`;

export const EmptyStateWrapper = styled.div`
  align-items: center;
  animation-duration: 600ms;
  animation-fill-mode: forwards;
  animation-name: sectionAppears;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 0 24px 0;
  padding: 31px 0 0 15px;

  @keyframes sectionAppears {
    0% {
      display: none;
      opacity: 0;
    }
    1% {
      display: flex;
      opacity: 0;
    }
    50% {
      display: flex;
      opacity: 0.5;
    }
    100% {
      display: flex;
      opacity: 1;
    }
  }
`;

export const EmptyTitle = styled(typography.SecondarySmall)`
  color: ${colors.TEXT_SECONDARY};
  padding: 16px 0 0;
`;
